import { CommonInput } from '@/components/_dashboard/promotion/formik/commonInput';
import { getDisplayInfoValidationList } from '@/components/_dashboard/promotion/tools';
import { getErrorMessage } from '@/utils/stringHelper';
import { Grid } from '@mui/material';
import React, { useCallback, useEffect, useMemo } from 'react';
import { IPromoProps } from '../type';
import { renderContent, tabContent } from './tabContent';

export const DisplayInfo: React.FC<IPromoProps> = (props) => {
    const { formik, setCanMoveFunc, setFieldTouchedNameFunc, isOfferVoucher = false } = props;
    const { values } = formik;
    const canMove = useCallback(async () => {
        // name is required
        // numberOfDeals is required and greater than 0
        let message = '';
        let canMove = true;
        try {
            const list = getDisplayInfoValidationList(isOfferVoucher);
            for (const path of list) {
                await setFieldTouchedNameFunc(path);
            }
        } catch (e) {
            message = getErrorMessage(e);
            canMove = false;
        }
        return {
            message: message,
            canMove: canMove
        };
    }, [setFieldTouchedNameFunc, values, isOfferVoucher]);

    const wrappedCanMove = useCallback(() => canMove(), [canMove]);
    useEffect(() => {
        setCanMoveFunc(() => wrappedCanMove);
    }, [setCanMoveFunc, wrappedCanMove]);

    const titlePath = useMemo(() => {
        return isOfferVoucher ? 'offerVoucherSettings.displaySettings.displayTitle' : 'displaySettings.displayTitle';
    }, [isOfferVoucher]);
    const titleValue = useMemo(() => {
        return isOfferVoucher
            ? formik.values.offerVoucherSettings?.displaySettings?.displayTitle
            : formik.values.displaySettings?.displayTitle;
    }, [isOfferVoucher, formik.values]);
    const altTitlePath = useMemo(() => {
        return isOfferVoucher ? 'offerVoucherSettings.displaySettings.displayAltTitle' : 'displaySettings.displayAltTitle';
    }, [isOfferVoucher]);
    const descriptionPath = useMemo(() => {
        return isOfferVoucher ? 'offerVoucherSettings.displaySettings.displayDescription' : 'displaySettings.displayDescription';
    }, [isOfferVoucher]);
    const descriptionValue = useMemo(() => {
        return isOfferVoucher
            ? formik.values.offerVoucherSettings?.displaySettings?.displayDescription
            : formik.values.displaySettings?.displayDescription;
    }, [isOfferVoucher, formik.values]);
    const altDescriptionPath = useMemo(() => {
        return isOfferVoucher ? 'offerVoucherSettings.displaySettings.displayAltDescription' : 'displaySettings.displayAltDescription';
    }, [isOfferVoucher]);
    const termsPath = useMemo(() => {
        return isOfferVoucher ? 'offerVoucherSettings.displaySettings.displayTerms' : 'displaySettings.displayTerms';
    }, [isOfferVoucher]);
    const imagePath = useMemo(() => {
        return isOfferVoucher ? 'offerVoucherSettings.displaySettings.displayImage' : 'displaySettings.displayImage';
    }, [isOfferVoucher]);

    // name = Title (Customer View)
    // description = Description (Customer View)
    useEffect(() => {
        // set title as name
        const title = titleValue || '';
        formik.setFieldValue('name', title);
    }, [titleValue]);
    useEffect(() => {
        // set description as description
        const description = descriptionValue || '';
        formik.setFieldValue('description', description);
    }, [descriptionValue]);

    const commonContents: tabContent[] = [
        {
            mdSize: 6,
            sxSize: 12,
            node: <CommonInput formik={formik} fieldPath={titlePath} label="Title (Customer View)" />
        },
        {
            mdSize: 6,
            sxSize: 12,
            node: <CommonInput formik={formik} fieldPath={altTitlePath} label="Alt Title (Customer View)" />
        },

        {
            mdSize: 12,
            sxSize: 12,
            node: <CommonInput formik={formik} multiline={true} fieldPath={descriptionPath} label="Description (Customer View)" />
        },
        {
            mdSize: 12,
            sxSize: 12,
            node: <CommonInput formik={formik} multiline={true} fieldPath={altDescriptionPath} label="Alt Description (Customer View)" />
        },

        {
            mdSize: 12,
            sxSize: 12,
            node: <CommonInput formik={formik} multiline={true} fieldPath={termsPath} label="Terms (Customer View)" />
        },
        {
            mdSize: 12,
            sxSize: 12,
            node: <CommonInput formik={formik} fieldPath={imagePath} label="Image (Customer View) current disabled" disabled={true} />
        }
    ];

    return (
        <Grid sx={{ width: '100%' }} container spacing={1}>
            {renderContent(commonContents)}
        </Grid>
    );
};
